export default __webpack_public_path__ + "static/media/13853.activity-committee.photo.70557958.jpg";